import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './AppointmentCalendar.LoadingConfig.styles';

const calendarLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.calendarHeader),
  },
  {
    main: setLoadingConfigObject('square', 7, null, styles.calendarWeeks),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.availableSlots),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.selectedDate),
  },
];

const bottomLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.divider),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.button),
  },
];

export { calendarLoadingConfig, bottomLoadingConfig, shimmerPlaceholderConfig };
